import { render, staticRenderFns } from "./Pendidikan.vue?vue&type=template&id=ba1bb71c"
import script from "./Pendidikan.vue?vue&type=script&lang=js"
export * from "./Pendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports